const ROOT = 'sidebar/sidebar';

export const RESET_VIEW_CIP_GENERATION = `${ROOT}/RESET_VIEW_CIP_GENERATION`;
export const RESET_VIEW_CIP_REPORT = `${ROOT}/RESET_VIEW_CIP_REPORT`;
export const RESET_APP_STATE = `${ROOT}RESET_APP_STATE`;
